// extracted by mini-css-extract-plugin
module.exports = {"twoCol":"gridlayout_twoCol__E3XpW"};